
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-we-buy/silver-buyers",
      function () {
        return require("private-next-pages/what-we-buy/silver-buyers/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-we-buy/silver-buyers"])
      });
    }
  